import { lazy } from 'react';
import withSuspense from '../../helpers/withSuspense';

const WorkQueueItems = withSuspense(lazy(() => import('./WorkQueueItems.jsx')));

export default WorkQueueItems;
